import {getRouteApi} from "@tanstack/react-router";

export const leadsRouteApi = getRouteApi("/_app/sales/leads/");
